import React, { createContext, useContext, useEffect, useState } from "react";
import { loadGoogleMapsApi } from "../utils/loadGoogleMapsApi";

const GoogleMapsContext = createContext();

export const useGoogleMaps = () => useContext(GoogleMapsContext);

export const GoogleMapsProvider = ({ apiKey, libraries, children }) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const [google, setGoogle] = useState(null);

    useEffect(() => {
        loadGoogleMapsApi(apiKey, libraries)
            .then(() => {
                setGoogle(window.google);
                setIsLoaded(true);
            })
            .catch((error) => {
                console.error("Error loading Google Maps API:", error);
            });
    }, [apiKey, libraries]);

    return (
        <GoogleMapsContext.Provider value={{ isLoaded, google }}>
            {children}
        </GoogleMapsContext.Provider>
    );
};
